import { useEffect, useState } from "react";

/** Below Carbon's `md` breakpoint the panel becomes a bottom sheet. */
export const NARROW_SCREEN = "(max-width: 767.98px)";

export const useNarrowScreen = (): boolean => {
  const [narrow, setNarrow] = useState(
    () => window.matchMedia?.(NARROW_SCREEN)?.matches ?? false
  );
  useEffect(() => {
    const query = window.matchMedia?.(NARROW_SCREEN);
    if (!query?.addEventListener) return;
    const onChange = (event: MediaQueryListEvent) => setNarrow(event.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);
  return narrow;
};
